const quantityWithBuyBtnContainer = document.querySelector(
  ".quantity-with-buy-btn"
);

const addLowerPrice = () => {
  if (quantityWithBuyBtnContainer) {
    const hulkPrice = document.querySelector(
      ".product .product__info-wrapper .price .price__regular .money"
    );
    if (!hulkPrice) return;
    const innerLowerPriceHtml = `<div class="lower-price-container">
    <span class="lower-price-label">
    Cena:
    </span>
    <span class="price__regular price__regular-HPO lower-price">
     ${hulkPrice.textContent}
     </span>
     </div>`;
    if (hulkPrice) {
      quantityWithBuyBtnContainer.insertAdjacentHTML(
        "beforebegin",
        innerLowerPriceHtml
      );
    }
  }
};

const hulkInterwal = setInterval(() => {
  const hulkappsProductOptions = document.querySelector(
    ".hulkapps_product_options"
  );
  if (hulkappsProductOptions) {
    clearInterval(hulkInterwal);
    addLowerPrice();
  }
}, 1000);
